import { BackendApiClient } from '../api-client';
import { azdanceBookingAuthHeaders } from '@/lib/azdanceBookingSession';

/**
 * GET /azdance/booking/participants — список участников брони (JWT с `eventBookingId`, query только `language`).
 */
export async function fetchAztangofestBookingParticipantsList(
  language: string,
  accessToken?: string | null,
) {
  return BackendApiClient.AzdanceService.azdanceControllerListBookingParticipants(
    { language },
    {
      headers: azdanceBookingAuthHeaders(accessToken ?? undefined),
    } as any,
  );
}
